class GiftQuantity extends QuantityInput {
  constructor() {
    super();
  }

  init() {
    super.init();
    
    this.giftWrapping = document.querySelectorAll('product-gift-wrapping');
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.wrappedItemsInCart = parseInt(this.getAttribute('wrapped-items-in-cart'));

    // If we have nothing but gift-wrap items in the cart.
    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      this.update();
    }
    // If we don't have the right amount of gift-wrap items in the cart.
    else if (this.giftWrapsInCart > 0 & this.giftWrapsInCart != this.wrappedItemsInCart) {
      this.update();
    }
    // If we have a gift-wrap item in the cart but our gift-wrapping product attribute has not been set.
    else if (this.giftWrapsInCart > 0 && this.giftWrapping.length == 0) {
      this.update();
    }
    // If we have no gift-wrap item in the cart but our gift-wrapping product attribute has been set.
    else if (this.giftWrapsInCart == 0 && this.giftWrapping.length > 0) {
      this.update();
    }
  }

  update() {
    this.input.value = this.wrappedItemsInCart;
    this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('gift-quantity', GiftQuantity);

class ProductGiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.productKey = this.dataset.productKey;
    this.productQuantity = parseInt(this.dataset.productQuantity);
    this.giftWrapId = this.dataset.giftWrapId;
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.wrappedItemsInCart = parseInt(this.getAttribute('wrapped-items-in-cart'));

    // When the gift-wrapping checkbox is checked or unchecked.
    this.querySelectorAll('input').forEach((input) => {
      input.addEventListener("change", (event) => {
        event.target.checked ? this.setProductGiftWrap() : this.removeProductGiftWrap();
      });
    });

    if (this.miniCart) return;

  }

  setProductGiftWrap() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');

    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: (this.giftWrapsInCart + 1)
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    // Add gift wrap to cart
    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(function() {
        let formData = {
          id: this.productKey,
          properties: {
            '_has_gift_wrap': true
          },
          quantity: this.productQuantity,
          sections: sections,
          sections_url: window.location.pathname
        };
        // Update product properties
        fetch(`${theme.routes.cart_change_url}`, { ...fetchConfig(), ...{ body: JSON.stringify(formData) } })
        .then((response) => response.json())
        .then((response) => {
          loadingOverlay.classList.add('hidden');

          if (document.body.classList.contains('template-cart')) {
            window.location.href = theme.routes.cart_url;
            return;
          }

          this.miniCart && this.miniCart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        });
      }.bind(this))
      .catch((e) => {
        console.error(e);
      });
  }

  removeProductGiftWrap() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');

    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: (this.giftWrapsInCart - 1)
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(function () {
        let formData = {
          id: this.productKey,
          properties: {
            '_has_gift_wrap': false
          },
          quantity: this.productQuantity,
          sections: sections,
          sections_url: window.location.pathname
        };
        // Update product properties
        fetch(`${theme.routes.cart_change_url}`, { ...fetchConfig(), ...{ body: JSON.stringify(formData) } })
        .then((response) => response.json())
        .then((response) => {
          loadingOverlay.classList.add('hidden');

          if (document.body.classList.contains('template-cart')) {
            window.location.href = theme.routes.cart_url;
            return;
          }

          this.miniCart && this.miniCart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        });
      }.bind(this))
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }
}
customElements.define('product-gift-wrapping', ProductGiftWrapping);